import { Typography, Table, Col } from "antd";
import { forwardRef, useImperativeHandle, useMemo } from "react";
import DpatSubIndicatorSection from "../setup/DpatSubIndicatorSection";
import DpatIndicatorCmsIntro from "../setup/DpatIndicatorCmsIntro";
import Comment from "components/Comments";
import CiResultDisplay from "./CiResultDisplay";
import {
    transformDpatTableRows,
    rowsHaveAllEvidenceLinks,
} from "utils/renderDpatEvidenceLink";

const { Title } = Typography;

const AUDIT_REPORT_LINK_KEYS = ["report"];
const REQUIRED_QUARTERLY_AUDITS = 4;

function resolveInternalAuditFulfillment(auditRows) {
    const rows = auditRows ?? [];
    return rows.length >= REQUIRED_QUARTERLY_AUDITS
        && rowsHaveAllEvidenceLinks(rows, AUDIT_REPORT_LINK_KEYS)
        ? "Fulfilled"
        : "Not Fulfilled";
}

const InternalAuditUnitFunctionality = forwardRef(({
    data,
    year,
    columns,
    district,
    hideComment,
    savedAssessmentData,
    isAssessmentStarted,
}, ref) => {
    const displayData = useMemo(() => {
        if (!isAssessmentStarted || !savedAssessmentData) {
            return data;
        }
        return savedAssessmentData.data ?? data;
    }, [isAssessmentStarted, savedAssessmentData, data]);

    const auditReportRows = transformDpatTableRows(
        displayData?.data,
        AUDIT_REPORT_LINK_KEYS,
        { report: "View Report" },
    );

    const fulfillment = useMemo(
        () => resolveInternalAuditFulfillment(displayData?.data),
        [displayData?.data],
    );

    useImperativeHandle(ref, () => ({
        getData: () => ({
            indicator: "CI3",
            area: "Public Financial Management and Auditing",
            data: displayData,
            fulfillment,
        }),
    }), [displayData, fulfillment]);

    const DPAT_SLUG = "c3.0-3.2";

    return (
       <Comment
        data={displayData}
        year={year}
        districtId={district}
        tableCommentedId={`c3.0-3.2-${year}`}
        hideComment={hideComment}
      >
        {({ renderCommentFeedbackFooter }) => (
          <DpatSubIndicatorSection code={DPAT_SLUG}>
            <DpatIndicatorCmsIntro
              year={year}
              slug={DPAT_SLUG}
            />

            <Col align="start">
              <CiResultDisplay slug={DPAT_SLUG} fulfillment={fulfillment} />
            </Col>

            <Title level={4} style={{ marginTop: "20px" }}>Evidence of Internal Audit Committee Reports</Title>
            {displayData && (
              <Table
                columns={columns}
                dataSource={auditReportRows}
                pagination={false}
                bordered
                rowKey={(record) => record.key ?? record.no}
              />
            )}
            {!hideComment && renderCommentFeedbackFooter()}
          </DpatSubIndicatorSection>
        )}
        </Comment>
    );
})

export default InternalAuditUnitFunctionality;
